import gql from 'graphql-tag';

const aboutUsQuery = gql`
    query MyQuery {
        aboutUsContent {
            displayText
            subtitle
            whiteTitle
            bannerImage {
                urls
            }
            teamList {
                contentItems {
                    ... on TeamMember {
                        displayText
                        jobTitle
                        image {
                            urls
                        }
                        bio {
                            html
                        }
                    }
                }
            }
            aboutUsContentFlow {
                contentItems {
                    ... on ContentBlockFlowpart {
                        displayText
                        image {
                            urls
                        }
                        imagePosition
                        markdownBody {
                            html
                        }
                        sectionStyle
                        contentBlockSubtitle
                    }
                    ... on Accordion {
                        displayText
                        subtitle
                        accordionContent {
                            contentItems {
                                ... on AccordionItem {
                                    displayText
                                    markdownBody {
                                        html
                                    }
                                }
                            }
                        }
                    }
                    ... on Buttons {
                        buttonList {
                            contentItems {
                                displayText
                                ... on LinkMenuItem {
                                    linkMenuItem {
                                        url
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export {
    aboutUsQuery
};